<template>
    <div style="height: 100vh;">
        <div style="">
            <a-card title="" style="border-radius: 20px;" :bordered="false">
                <div class="actions">

                    <p style="margin-left: 10px; margin-top: 3px; font-size: 15px; color: #05004E">Add New Lead</p>

                    <div style="display:flex; justify-content: space-around;">
                        <!-- <a-button @click="showLowStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" >
                        Replenish Low Stock
                        <span class="px-2"> <a-badge :count="balLessThan20.length" show-zero :number-style="{ backgroundColor: '#52c41a' }"/></span>
                        </a-button> -->


                        <!-- <a-button @click="showOutOfStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" > -->


                        <router-link to="/pipeline/contacts">
                            <a-button style="border-raduis:6px; background: #fff;color:#0F3659; margin-right:10px;">
                                Cancel
                            </a-button>
                        </router-link>

                        <a-button :loading="loading" @click="handleAddLead"
                            style="border-raduis:6px; background: #26A246;color:#fff">
                            Save
                        </a-button>

                    </div>
                </div>

                <div style="margin-top: 30px; margin-bottom: 30px;">
                    <div>
                        <!-- <div>
                            <p
                                style="display:flex;justify-content: start;margin-top: 5px;font-size:15px; color: #9197B3;">
                                Contact Image
                            </p>
                            <div class="clearfix mt-3">
                                <a-upload action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    list-type="picture-card" :file-list="fileList" :beforeUpload="beforeUpload"
                                    @preview="handlePreview" @change="handleChange" class="upload">
                                    <div>
                                        <a-icon type="plus" />
                                        <div class="ant-upload-text">
                                            Upload
                                        </div>
                                    </div>
                                </a-upload>
                                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                                    <img alt="example" style="width: 100%" :src="previewImage" />
                                    <h4 style="display:flex;justify-content: center;margin-top:15px">Image Name: <span
                                            style="margin-left:10px">{{ fileSelected.name }}</span></h4>
                                    <div style="display:flex;justify-content: center;">
                                    </div>
                                </a-modal>
                            </div>
                        </div> -->
                        <div>
                            <div>
                                <a-form-model ref="addLeadRef" :model="addLeadModel" :rules="rules">
                                    <p
                                        style="display:flex;justify-content: start;margin-top: 10px;font-size:15px; color: #9197B3;">
                                        Lead Information
                                    </p>
                                    <a-row>
                                        <a-col :md="8" :lg="12" :xl="12">
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="userId" label="Lead Owner" prop="userId">
                                                <a-select v-model="addLeadModel.userId" placeholder="">
                                                    <a-select-option v-for="owner in clients.data" :key="owner.id">
                                                        {{ owner.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>

                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="firstName" label="First Name" prop="firstName">
                                                <a-input v-model="addLeadModel.firstName" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="lastName" label="Last Name" prop="lastName">
                                                <a-input v-model="addLeadModel.lastName" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="title" label="Title" prop="title">
                                                <a-select v-model="addLeadModel.title" placeholder="">
                                                    <a-select-option value="0">
                                                        Mr
                                                    </a-select-option>
                                                    <a-select-option value="1">
                                                        Mrs
                                                    </a-select-option>
                                                    <a-select-option value="2">
                                                        Miss
                                                    </a-select-option>
                                                    <a-select-option value="3">
                                                        Dr
                                                    </a-select-option>
                                                    <a-select-option value="4">
                                                        Prof
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="position" label="Position" prop="position">
                                                <a-input v-model="addLeadModel.position" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="phoneNumber" label="Phone" prop="phoneNumber">
                                                <a-input v-model="addLeadModel.phoneNumber" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="source" label="Lead Source" prop="source">
                                                <a-select v-model="addLeadModel.source" placeholder="">
                                                    <a-select-option value="0">
                                                        Outreach Events
                                                    </a-select-option>
                                                    <a-select-option value="1">
                                                        Referrals
                                                    </a-select-option>
                                                    <a-select-option value="2">
                                                        Inbund Marketing
                                                    </a-select-option>
                                                    <a-select-option value="3">
                                                        Cold Calling
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="expectedRevenue" label="Expected Revenue" prop="expectedRevenue">
                                                <a-input suffix="Ksh" v-model="addLeadModel.expectedRevenue" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="emailOpt" label="Email Opt Out" prop="emailOpt">
                                                <a-switch v-model="addLeadModel.emailOpt" />
                                            </a-form-model-item>

                                            <!-- <a-form-model-item ref="name" label="Email Opt Out" prop="name">
                                                <a-switch />
                                            </a-form-model-item> -->
                                        </a-col>
                                        <a-col :md="8" :lg="12" :xl="12">
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="accountName" label="Account Name" prop="accountName">
                                                <a-input v-model="addLeadModel.accountName" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="accountType" label="Account Type" prop="accountType">
                                                <a-select v-model="addLeadModel.accountType" placeholder="">
                                                    <a-select-option value="0">
                                                        Agrovet
                                                    </a-select-option>
                                                    <a-select-option value="1">
                                                        AHP
                                                    </a-select-option>
                                                    <a-select-option value="2">
                                                        Cooperative
                                                    </a-select-option>
                                                    <a-select-option value="3">
                                                        Hatchery
                                                    </a-select-option>
                                                    <a-select-option value="4">
                                                        Staff
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="email" label="Email" prop="email">
                                                <a-input v-model="addLeadModel.email" />
                                            </a-form-model-item>

                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="website" label="Website" prop="website">
                                                <a-input v-model="addLeadModel.website" />
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="employeeCount" label="No. of Employees" prop="employeeCount">
                                                <a-input v-model="addLeadModel.employeeCount" />
                                            </a-form-model-item>




                                        </a-col>
                                    </a-row>
                                    <p
                                        style="display:flex;justify-content: start;margin-top: 10px;font-size:15px; color: #9197B3;">
                                        Address Information
                                    </p>
                                    <a-row>
                                        <a-col :span="8">
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="country" label="Country" prop="country">
                                                <a-select v-model="addLeadModel.country" placeholder="">
                                                    <a-select-option value="0">
                                                        Ghana
                                                    </a-select-option>
                                                    <a-select-option value="1">
                                                        Kenya
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="region" label="Region" prop="region">
                                                <a-select @change="handleRegionChange" v-model="addLeadModel.region"
                                                    placeholder="">
                                                    <a-select-option v-for="region in regions" :key="region.id">
                                                        {{ region.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="subRegion" label="Sub Region" prop="subRegion">
                                                <a-select @change="handleSubRegionChange"
                                                    v-model="addLeadModel.subRegion" placeholder="">
                                                    <a-select-option v-for="subRegion in subRegions"
                                                        :key="subRegion.id">
                                                        {{ subRegion.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                            <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol"
                                                ref="communityId" label="Town" prop="communityId">
                                                <a-select @change="''" v-model="addLeadModel.communityId"
                                                    placeholder="">
                                                    <a-select-option v-for="town in towns" :key="town.id">
                                                        {{ town.name }}
                                                    </a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                        </a-col>
                                    </a-row>

                                </a-form-model>
                            </div>
                        </div>
                    </div>
                </div>
            </a-card>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default {
    name: 'AddContact',
    components: {

    },
    data() {
        return {
            current: 0,
            activeKey: ['0'],
            showProductCategoryTab: false,
            showProductTab: true,
            showProductImageTab: true,
            showInventoryTab: true,
            fileList: [],
            previewVisible: false,
            previewImage: '',
            imgSelected: false,
            fileSelected: {},
            selectedValue: "",
            newFilelist: [],
            labelCol: { span: 8 },
            wrapperCol: { span: 15 },
            sources: [],
            loading: false,
            dateFormat: 'DD-MM-YYYY',
            addLeadModel: {
                userId: '',
                communityId: "",
                firstName: "",
                lastName: "",
                accountName: "",
                accountType: "",
                source: "",
                address: "",
                phoneNumber: "",
                otherPhoneNumber: "",
                expectedRevenue:"",
                email: "",
                region: "",
                country: "",
                position: "",
                department: "",
                description: "",
                dateOfBirth: "",
                title: "",
                employeeCount: null,
                website: "",
                isPrimary: null,
                emailOpt: null,
                smsOpt: null,
            },
            regions: [],
            subRegions: [],
            towns: [],
            rules: {
                firstName: [
                    { required: true, message: 'Please enter first name', trigger: 'change' },
                ],
                lastName: [
                    { required: true, message: 'Please enter last name', trigger: 'change' },
                ],
                userId: [
                    { required: true, message: 'Please select contact owner', trigger: 'change' },
                ],
                communityId: [
                    { required: true, message: 'Please select community', trigger: 'change' },
                ],
                accountName: [
                    { required: true, message: 'Please enter account name', trigger: 'change' },
                ],
                accountType: [
                    { required: true, message: 'Please select account type', trigger: 'change' },
                ],
                source: [
                    { required: true, message: 'Please select source', trigger: 'change' },
                ],

                phoneNumber: [
                    { required: true, message: 'Please enter phone number', trigger: 'change' },
                ],

                email: [
                    { required: true, message: 'Please enter email', trigger: 'change' },
                ],
                country: [
                    { required: true, message: 'Please select option', trigger: 'change' },
                ],
                region: [
                    { required: true, message: 'Please select option', trigger: 'change' },
                ],
                subRegion: [
                    { required: true, message: 'Please select option', trigger: 'change' },
                ],

                title: [
                    { required: true, message: 'Please select option', trigger: 'change' },
                ],

            }
        };
    },
    computed: {
        ...mapGetters(['getStepCount']),
        clients() {
            return this.$store.getters["generic/GetUsers"];
        },
    },
    methods: {
        ...mapActions(['setStepCount', 'setProductGroupInfo', 'getAllCommunitiesById', 'getAllSubRegionById', 'getAllRegion', 'setProductDetailsInfo']),
        // onChange(current) {
        //     // console.log('onChange:', current);
        //     this.current = current;
        //     if(current === 0){
        //         this.setStepCount(0)
        //         this.$router.push(`/new-product`).catch(()=>{});
        //     }else if(current === 1){
        //         this.setStepCount(1)
        //         this.$router.push(`/product-details`).catch(()=>{});
        //     }
        //     else if(current === 2){
        //         this.setStepCount(2)
        //         this.$router.push(`/product-image`).catch(()=>{});
        //     }else if(current === 3){
        //         this.setStepCount(3)
        //         this.$router.push(`/inventory-details`).catch(()=>{});
        //     }
        // },

        redirectUrl() {
            this.$router.push(`/customers`).catch(() => { });
        },

        async handleRegionChange(id) {
            const response = await this.getAllSubRegionById(id);
            this.subRegions = response.data.data;
        },

        async handleSubRegionChange(id) {
            const response = await this.getAllCommunitiesById(id);
            this.towns = response.data.data;
        },

        handleAddLead() {
            this.$refs.addLeadRef.validate(async valid => {
                if (valid) {
                    this.loading = true;
                    console.log("Request | ", this.addLeadModel)
                    const request = {

                        userId: this.addLeadModel.userId,
                        title: parseInt(this.addLeadModel.title),
                        communityId: this.addLeadModel.communityId,
                        firstName: this.addLeadModel.firstName,
                        lastName: this.addLeadModel.lastName,
                        accountName: this.addLeadModel.accountName,
                        accountType: parseInt(this.addLeadModel.accountType),
                        source: parseInt(this.addLeadModel.source),
                        address: this.addLeadModel.address,
                        phoneNumber: this.addLeadModel.phoneNumber,
                        otherPhoneNumber: this.addLeadModel.otherPhoneNumber,
                        email: this.addLeadModel.email,
                        position: this.addLeadModel.position,
                        expectedRevenue: parseFloat(this.addLeadModel.expectedRevenue),
                        employeeCount: parseInt(this.addLeadModel.employeeCount),
                        website: this.addLeadModel.website,
                        department: this.addLeadModel.department,
                        description: this.addLeadModel.description,
                        isPrimary: this.addLeadModel.isPrimary ? true : false,
                        emailOpt: this.addLeadModel.emailOpt ? true : false,
                        smsOpt: this.addLeadModel.smsOpt ? true : false
                    }

                    console.log("Request | ", request);

                    const response = await this.$store.dispatch("pipeline/addLead", request);

                    this.loading = false
                    if (response.status === 200) {
                        this.showSuccessAlert("New Lead Created Successfully");
                        this.$refs.addLeadRef.resetFields();
                        this.$router.push(`/pipeline/leads`).catch(() => { });
                    } else {
                        this.showErrorAlert(response.data.messages)
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        handleChange({ fileList }) {
            this.fileList = fileList;
        },
        handleCancel() {
            this.previewVisible = false;
        },
        beforeUpload(file) {
            // console.log("file type | ", file.type)
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

            if (!isJpgOrPng) {
                this.fileList = [];
                this.showErrorAlert("You can only upload PNG or JPEG file!")
                // console.log("fileList not png | ", this.fileList)
                return false;
            } else {
                // console.log("fileList png | ", this.fileList)
                this.fileList = [...this.fileList, file];
                return false;
            }
        },
       
        async handlePreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.fileSelected = file
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        async loadRegions() {
            const response = await this.getAllRegion();
            this.regions = response.data.data
        },

    },
    created() {
      
        this.loadRegions();
        this.$store.dispatch("generic/FetchUsers", { perPage: -1 });
    },
}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.img_size {
    max-width: 56px;
    max-height: 55px;
}

.rightSideinputText {
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}

.descInputText {
    /* height: 50px; */
    width: 336px;
    border-radius: 5px;
}

.dropdownItem {
    width: 336px;
    border-radius: 5px;
}

.selecInput {
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}

.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
    color: #98c14b;
    font-size: 48px;
}

.ant-layout-sider {
    background: #FFFFFF;
}

.slider>>>.ant-steps-item-process .ant-steps-item-icon {
    background: #418a49;
}

.slider>>>.ant-steps-item-process .ant-steps-item-icon {
    border-color: #418a49;
}

.slider>>>.ant-steps-item-process .ant-steps-item-icon:hover {
    color: #418a49;
}

.slider>>>.anticon {
    vertical-align: 2px;
}

.slider>>>.ant-steps-item-finish .ant-steps-item-icon {
    background-color: #fff;
    border-color: #418a49;
}

.slider>>>.ant-steps-item-finish .ant-steps-item-icon>.ant-steps-icon {
    color: #418a49;
}

.slider>>>.ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
    background-color: #418a49;
}

.slider {
    flex: none !important;
    max-width: none !important;
    min-width: none !important;
    width: 250px !important;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.upload-list-inline>>>.ant-upload-list-item {
    float: left;
    width: 200px;
    margin-right: 8px;
}

.upload-list-inline>>>.ant-upload-animate-enter {
    animation-name: uploadAnimateInlineIn;
}

.upload-list-inline>>>.ant-upload-animate-leave {
    animation-name: uploadAnimateInlineOut;
}

.ant-collapse-borderless {
    background-color: #fff;
    border: 0;
}
</style>
